// Rótulos PT-BR dos comandos ACTION no card do dock. Registry de dados puro extraído
// do ActionCard (guardrail max-lines). Fallback: o próprio nome do comando (dot.case).
export const ACTION_LABEL: Record<string, string> = {
  "scenario.preview": "Pré-visualizar cenário",
  "scenario.create": "Criar cenário",
  "simulation.run": "Executar simulação",
  "simulation.suggestImprovements": "Sugerir melhorias",
  "simulation.cancelBatch": "Cancelar lote de simulação",
  "simulation.interpret": "Interpretar simulação",
  "simulation.interpretComparison": "Interpretar comparação",
  "simulation.interpretBatch": "Interpretar sugestões",
  "alarm.acknowledge": "Reconhecer alarme",
  "alarm.resolve": "Resolver alarme",
  "alarm.markFalse": "Marcar alarme como falso",
  "machineEvent.acknowledge": "Reconhecer evento",
  "machineEvent.justify": "Justificar evento",
  "production.pause": "Pausar produção",
  "production.resume": "Retomar produção",
  "production.finish": "Finalizar produção",
  "production.recordEntry": "Apontar produção",
  "production.registerLoss": "Registrar refugo",
  "production.updatePlannedTimes": "Ajustar tempos planejados",
  "productionOrder.create": "Criar ordem de produção",
  "productionOrder.update": "Editar ordem de produção",
  "productionOrder.cancel": "Cancelar ordem de produção",
  "line.create": "Criar linha",
  "line.update": "Editar linha",
  "line.delete": "Excluir linha",
  "machine.create": "Criar máquina",
  "machine.update": "Editar máquina",
  "machine.duplicate": "Duplicar máquina",
  "machine.delete": "Excluir máquina",
  "product.create": "Criar produto",
  "product.update": "Editar produto",
  "product.delete": "Excluir produto",
  "device.create": "Cadastrar CLP",
  "device.rotateKey": "Rotacionar chave do CLP",
  "device.delete": "Excluir CLP",
  "sensor.linkToParameter": "Vincular sensor",
  "sensor.unlink": "Desvincular sensor",
  // Parâmetros & apontamentos
  "parameter.create": "Criar parâmetro",
  "parameter.update": "Editar parâmetro",
  "parameter.delete": "Excluir parâmetro",
  "parameter.recordEntry": "Apontar medição",
  "machine.recordStatus": "Registrar status da máquina",
  // Config de relações
  "machine.setCompatibility": "Definir compatibilidade",
  "machine.setSimilar": "Definir máquina semelhante",
  "scenario.setMachineSimParams": "Ajustar parâmetros de simulação",
  // Admin de dispositivos
  "device.update": "Editar CLP",
  "card.create": "Criar cartão",
  "card.update": "Editar cartão",
  "card.delete": "Excluir cartão",
  "sensor.create": "Criar sensor",
  "sensor.update": "Editar sensor",
  "sensor.delete": "Excluir sensor",
};
